import script from "./dx-treeSelects.vue?vue&type=script&setup=true&lang=js"
export * from "./dx-treeSelects.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__